import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all locale files
import enTranslation from './locales/en.json';
import deTranslation from './locales/de.json';
import frTranslation from './locales/fr.json';
import esTranslation from './locales/es.json';
import itTranslation from './locales/it.json';
import plTranslation from './locales/pl.json';
import svTranslation from './locales/sv.json';
import daTranslation from './locales/da.json';
import ptTranslation from './locales/pt.json';
import fiTranslation from './locales/fi.json';
import elTranslation from './locales/el.json';
import csTranslation from './locales/cs.json';
import nlTranslation from './locales/nl.json';

const resources = {
  en: { translation: enTranslation },
  de: { translation: deTranslation },
  fr: { translation: frTranslation },
  es: { translation: esTranslation },
  it: { translation: itTranslation },
  pl: { translation: plTranslation },
  sv: { translation: svTranslation },
  da: { translation: daTranslation },
  pt: { translation: ptTranslation },
  fi: { translation: fiTranslation },
  el: { translation: elTranslation },
  cs: { translation: csTranslation },
  nl: { translation: nlTranslation }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true, // Enable debug for testing
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Use manual detection to avoid conflicts with URL routing
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    // Ensure language changes trigger re-renders
    react: {
      useSuspense: false
    }
  });

// Add event listener for language changes
i18n.on('languageChanged', (lng) => {
  console.log(`[i18n] Language changed to: ${lng}`);
});

export default i18n;